import { useEffect, useState, useContext } from "react";
import { OrganizationContext } from "../contexts/OrganizationContextProvider";
import { getOrganizationPapers, deletePaper } from "../api/Api";
import Box from "../components/ui/Box";
import { Container } from "react-bootstrap";
import { RiArticleLine } from "react-icons/ri";
import DeleteModel from "../components/modals/DeleteModel";
import { showToast } from "../utils/toastUtils";
import BreadCrumb from "../components/BreadCrumb";
import PaperList from "../components/cards/PaperList";
import CircularIndeterminate from "../components/CircularIndeterminate";
import Pagination from "../components/ui/Pagination";

const PAPERS_PER_PAGE = 8; // Number of papers to display per page

// used in previous uploads page
function PreviousUploads() {
  const { data: organization } = useContext(OrganizationContext);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [deleteModelPaperId, setDeleteModelPaperId] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: PAPERS_PER_PAGE,
    totalItems: 0,
  }); // Pagination state
  const { currentPage, pageSize, totalItems } = pagination;

  // Fetch papers when the component mounts or when organization changes
  // and when currentPage or pageSize changes
  useEffect(() => {
    const fetchPapers = async () => {
      if (!organization?.current_organization?.id) return;
      try {
        const papersData = await getOrganizationPapers(
          organization.current_organization.id,
          currentPage,
          pageSize
        );
        setPapers(papersData?.data || []);
        setPagination((prev) => ({
          ...prev,
          totalItems: papersData?.pagination?.total_items || 0,
          currentPage: papersData?.pagination?.current_page || 1,
        }));
      } catch (error) {
        console.error("Error fetching papers:", error);
        setPapers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPapers();
  }, [organization, currentPage, pageSize]);

  // Handle menu item click from PaperCard
  const handleMenuItemClick = async (item, value) => {
    if (item === "Delete") {
      setDeleteModelPaperId(value);
      setOpen(true);
    }
  };

  // Close the delete confirmation alert
  // This function is called when the user clicks the close button or cancels the delete action
  const closeAlert = () => {
    setOpen(false);
    setDeleteModelPaperId(null);
  };

  // Handle paper deletion
  // This function is called when the user confirms the deletion of a paper
  const handleDeletePaper = (paperId) => {
    console.log("Deleting paper with ID:", paperId);

    deletePaper(paperId)
      .then((response) => {
        if (response?.status === 200) {
          setPapers((prevPapers) =>
            prevPapers.filter((paper) => paper.id !== paperId)
          );
          showToast("Paper deleted successfully", "success");
        } else {
          showToast(response?.message || "Error deleting paper", "error");
        }
      })
      .catch((error) => {
        showToast(
          error.response?.data?.message || "Error loading data",
          "error"
        );
      });
    closeAlert();
  };

// Breadcrumb array for navigation
  const array = [
    { title: "Manuscript Validator", link: `/manuscript-validator` },
    { title: "Previous Uploads", link: "/" },
  ];

  return (
    <div>
      {loading ? (
        <CircularIndeterminate />
      ) : (
        <div className="d-flex gap-3 p-3 h-100">
          <div className={`rounded-4 overflow-hidden w-100`}>
            <Box className="p-3 h-100 w-100">
              <BreadCrumb array={array} />
              <Container
                className="pb-3 rounded-4 "
                style={{
                  padding: 0,
                  border: "1px solid #f0efef",
                  background: "transparent",
                  maxWidth: "100%",
                }}
              >
                <div
                  className="d-flex flex-column flex-sm-row justify-content-between align-items-center px-4"
                  style={{ background: "#e5f6ff" }}
                >
                  <div className="d-flex align-items-center">
                    <h5 className="d-flex align-items-center my-3 gap-2 ">
                      <RiArticleLine size={30} />
                      <span>Previous Uploads</span>
                    </h5>
                  </div>
                </div>

                <PaperList
                  papers={papers}
                  handleMenuItemClick={handleMenuItemClick}
                />

                <Pagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  onPageChange={(page) => {
                    setPagination((prev) => ({
                      ...prev,
                      currentPage: page,
                    }));
                  }}
                  pageSize={pageSize}
                />
                
              </Container>
            </Box>
          </div>
        </div>
      )}
      <DeleteModel
        open={open}
        closeAlert={closeAlert}
        onClick={() => handleDeletePaper(deleteModelPaperId)}
        type="Paper"
      />
    </div>
  );
}

export default PreviousUploads;
